import "./App.css";
import { Route, Routes } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { lazy, Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import RequireAuth from "./utils/RequireAuth";
import Snackbars from "./components/Snackbars";
import { selectAccessToken, selectRefreshToken } from "./slices/auth";

const Home = lazy(() => import("./pages/Dashboard"));
const Login = lazy(() => import("./pages/Login"));
const PasswordReset = lazy(() => import("./pages/PasswordReset"));
const SetPassword = lazy(() => import("./pages/SetPassword"));

function App() {
  const accessToken = useSelector(selectAccessToken);
  const refreshToken = useSelector(selectRefreshToken);
  useEffect(() => {
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
    } else {
      localStorage.removeItem("accessToken");
    }
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
    } else {
      localStorage.removeItem("refreshToken");
    }
  }, [accessToken, refreshToken]);
  return (
    <>
      <CssBaseline />
      <Snackbars />
      <Suspense fallback={null}>
        <Routes>
          <Route
            path="/*"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
            index
          />
          <Route path="/login" element={<Login />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/set-password" element={<SetPassword />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
